import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexComponent } from './index.component';
import { TaskPanelLauncherComponent } from '../../../../@fury/shared/task-panel-launcher/task-panel-launcher.component';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    data: {
      title: 'Openstaan taken',
      permissions: [
        'tasks.create',
        'tasks.update',
        'tasks.delete',
        'tasks.reopen',
        'tasks.forward',
        'tasks.print',
        'tasks.handle',
        'tasks.view.all',
        'tasks.view.outside-of-tiles',
        'tasks.view',
      ]
    },
    children: [
      {
        path: 'nieuw',
        component: TaskPanelLauncherComponent,
        data: {
          title: 'Nieuwe taak',
          permissions: [
            'tasks.create',
          ]
        }
      },
      {
        path: 'bekijk/:task_id',
        component: TaskPanelLauncherComponent,
        data: {
          title: 'Bekijk taak',
          permissions: [
            'tasks.update',
            'tasks.delete',
            'tasks.reopen',
            'tasks.forward',
            'tasks.print',
            'tasks.handle',
            'tasks.view.all',
            'tasks.view',
          ]
        }
      }
    ]
  },
  {
    path: 'gesloten',
    component: IndexComponent,
    data: {
      title: 'Gesloten taken',
      permissions: [
        'tasks.create',
        'tasks.update',
        'tasks.delete',
        'tasks.reopen',
        'tasks.forward',
        'tasks.print',
        'tasks.handle',
        'tasks.view.all',
        'tasks.view',
      ],
    },
    children: [
      {
        path: 'nieuw',
        component: TaskPanelLauncherComponent,
        data: {
          title: 'Nieuwe taak',
          permissions: [
            'tasks.create',
          ]
        }
      },
      {
        path: 'bekijk/:task_id',
        component: TaskPanelLauncherComponent,
        data: {
          title: 'Bekijk taak',
          permissions: [
            'tasks.create',
            'tasks.update',
            'tasks.delete',
            'tasks.reopen',
            'tasks.forward',
            'tasks.print',
            'tasks.handle',
            'tasks.view.all',
            'tasks.view',
          ]
        }
      }
    ]
  },
  {
    path: 'alle',
    component: IndexComponent,
    data: {
      title: 'Alle taken',
      permissions: [
        'tasks.view.all',
      ],
    },
    children: [
      {
        path: 'nieuw',
        component: TaskPanelLauncherComponent,
        data: {
          title: 'Nieuwe taak',
          permissions: [
            'tasks.create',
          ]
        }
      },
      {
        path: 'bekijk/:task_id',
        component: TaskPanelLauncherComponent,
        data: {
          title: 'Bekijk taak',
          permissions: [
            'tasks.create',
            'tasks.update',
            'tasks.delete',
            'tasks.reopen',
            'tasks.forward',
            'tasks.print',
            'tasks.handle',
            'tasks.view.all',
            'tasks.view',
          ]
        }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndexRoutingModule {
}
